import * as React from 'react';

import { cn } from '@/shared/libs/utils/cn';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  slim?: boolean;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className, slim, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        'mx-auto w-full px-2 md:px-5',
        slim ? 'max-w-[1200px]' : 'max-w-[1600px]',
        className,
      )}
      {...rest}>
      {children}
    </div>
  ),
);

Container.displayName = 'Container';
